export default function ContactSection() {
  return (
    <footer id="contact" className="bg-[#F9F6F0] pt-32 pb-16 px-20">
      <div className="max-w-[1440px] mx-auto">
        <div className="grid grid-cols-4 gap-12 mb-16">
          <div>
            <h4 className="text-[22px] font-bold text-[#2B2B2B] mb-4">
              KOLOS d.o.o.
            </h4>
            <p className="text-[15px] font-light text-[#7A7A7A]">
              iOS Development Excellence
            </p>
          </div>

          <div>
            <h5 className="text-sm uppercase tracking-[1.5px] text-[#8B8B8B] mb-5">
              Location
            </h5>
            <div className="space-y-2">
              <div className="flex items-start gap-3">
                <div className="w-5 h-5 flex items-center justify-center mt-0.5">
                  <i className="ri-map-pin-line text-[#5F5F5F]"></i>
                </div>
                <div className="text-base text-[#5F5F5F] leading-relaxed">
                  <div>Jozefinska cesta 53</div>
                  <div>Duga Resa</div>
                  <div>47250</div>
                  <div>Croatia</div>
                </div>
              </div>
            </div>
          </div>

          <div>
            <h5 className="text-sm uppercase tracking-[1.5px] text-[#8B8B8B] mb-5">
              Get in Touch
            </h5>
            <div className="space-y-4">
              <div>
                <div className="text-sm text-[#8B8B8B] mb-1">Email</div>
                <div className="flex items-center gap-3">
                  <div className="w-5 h-5 flex items-center justify-center">
                    <i className="ri-mail-line text-[#5F5F5F]"></i>
                  </div>
                  <a href="mailto:help@kolosdoo.com" className="text-base text-[#2B2B2B] hover:text-[#8B6F47] transition-colors cursor-pointer">
                    help@kolosdoo.com
                  </a>
                </div>
              </div>
              <div>
                <div className="text-sm text-[#8B8B8B] mb-1">Phone</div>
                <div className="flex items-center gap-3">
                  <div className="w-5 h-5 flex items-center justify-center">
                    <i className="ri-phone-line text-[#5F5F5F]"></i>
                  </div>
                  <a href="tel:+17173220577" className="text-base text-[#2B2B2B] hover:text-[#8B6F47] transition-colors cursor-pointer">
                    +1 7173220577
                  </a>
                </div>
              </div>
            </div>
          </div>

          <div className="text-right">
            <div className="text-lg text-[#4A4A4A] mb-2" style={{ fontFamily: 'Crimson Pro, serif' }}>
              © 2025 KOLOS d.o.o.
            </div>
            <div className="text-sm font-light text-[#7A7A7A] mb-8">
              All rights reserved
            </div>
          </div>
        </div>

        <div className="pt-8 border-t border-[#E8E3DB] flex items-center justify-between">
          <div className="w-[480px] h-[280px] rounded-[20px] overflow-hidden shadow-lg">
            <img
              src="https://public.readdy.ai/ai/img_res/0d54deb900f729f83af14d8b494e057a.jpg"
              alt="KOLOS Office Workspace"
              className="w-full h-full object-cover"
            />
          </div>

          <div className="flex-1 px-16 text-center">
            <blockquote className="text-[32px] italic text-[#4A4A4A] leading-snug" style={{ fontFamily: 'Crimson Pro, serif' }}>
              "Innovation distinguishes between<br />
              a leader and a follower."
            </blockquote>
          </div>

          <div className="text-sm text-[#7A7A7A]">
            <a href="https://readdy.ai/?ref=logo" target="_blank" rel="noopener noreferrer" className="hover:text-[#8B6F47] transition-colors cursor-pointer whitespace-nowrap">
              Powered by Readdy
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
}
